import React from 'react'
// hooks
import { useModalData } from 'hooks'
// components
import { Button, Modal } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// views
import { ButtonGroup, Content, Countdown, Message, Title } from './views'

const COUNTDOWN_SECONDS = 120 // 2 minutes

const SessionExpiringModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, onContinue, onLogout }
  } = useModalData<{ onContinue?: () => void; onLogout?: () => void }>({
    modalType: Modals.SESSION_EXPIRING_MODAL
  })

  const [secondsLeft, setSecondsLeft] = React.useState(COUNTDOWN_SECONDS)

  React.useEffect(() => {
    if (!isOpen) {
      setSecondsLeft(COUNTDOWN_SECONDS)
      return
    }

    setSecondsLeft(COUNTDOWN_SECONDS)

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval)
          hideModal()
          onLogout?.()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [isOpen])

  const handleContinue = () => {
    hideModal()
    onContinue?.()
  }

  const handleLogout = () => {
    hideModal()
    onLogout?.()
  }

  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60

  return (
    <Modal isOpen={isOpen} onClose={handleContinue} disableBackdropClick disableEscapeKeyDown>
      <Content>
        <Title>Session Expiring</Title>
        <Message>Your session is about to expire due to inactivity.</Message>
        <Countdown>
          {minutes}:{seconds.toString().padStart(2, '0')}
        </Countdown>
        <Message>Click "Continue" to stay logged in.</Message>
        <ButtonGroup>
          <Button layout='RED_INVERTED' onClick={handleLogout}>
            Log Out
          </Button>
          <Button variant='contained' onClick={handleContinue}>
            Continue
          </Button>
        </ButtonGroup>
      </Content>
    </Modal>
  )
}

export default SessionExpiringModal
